export const createLoggingMiddleware = (isDev: boolean) => {
  return {
    onRequest: (config: any) => {
      // console.log('Request Details:', {
      //   url: config.url,
      //   baseURL: config.baseURL,
      //   fullUrl: `${config.baseURL}${config.url}`,
      //   method: config.method,
      //   headers: config.headers,
      //   isDev,
      //   proxyPath: '/dev-proxy/roboneoApi',
      // });
      return config;
    },
    onResponse: (response: any) => {
      // console.log('Response Details:', {
      //   status: response.status,
      //   statusText: response.statusText,
      //   headers: response.headers,
      //   data: response.data,
      //   config: {
      //     url: response.config.url,
      //     baseURL: response.config.baseURL,
      //     fullUrl: `${response.config.baseURL}${response.config.url}`,
      //   },
      // });
      return response;
    },
  };
};
